module.exports = __webpack_public_path__ + "img/two.54eb4452.png";